var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAccessControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.779,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f0bbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3136",
    "data-name": "Rectangle 3136",
    width: 80,
    height: 80,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_access_control",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9102",
    "data-name": "Group 9102",
    transform: "translate(1.388 1.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_281",
    "data-name": "Union 281",
    d: "M37.671,77.819a1.939,1.939,0,0,1-1.609-1.026,26.643,26.643,0,0,0-3-4.983,19.969,19.969,0,0,1-3.649-5.341c-2.722-6.219-4.73-10.666-5.973-13.217-.275-.567-.419-1.219.32-1.455a6.732,6.732,0,0,1,2.056-.292,4.709,4.709,0,0,1,2.88,1.543c.934.935,2.468,2.821,4.971,5.976a1.7,1.7,0,0,0,3.029-1.056V33.185a2.382,2.382,0,1,1,4.765,0V51.846a1.7,1.7,0,1,0,3.4,0v-8.16a2.383,2.383,0,1,1,4.765,0v8.16a1.7,1.7,0,1,0,3.4,0v-5.1a2.382,2.382,0,1,1,4.765,0v5.1a1.7,1.7,0,1,0,3.4,0V49.807a2.383,2.383,0,1,1,4.765,0V66.128a16.579,16.579,0,0,1-1.516,6.718,37.468,37.468,0,0,0-1.172,3.873,1.519,1.519,0,0,1-1.4,1.1ZM27.081,41.355a2.217,2.217,0,0,1-2.192-2.219V32.812H8.861A4.438,4.438,0,0,1,4.6,35.694a4.574,4.574,0,1,1,0-9.148A4.711,4.711,0,0,1,8.861,29.4H24.889V21.639L12.047,8.831a4.594,4.594,0,1,1,2.819-4.244A4.512,4.512,0,0,1,14.51,6.35L25.934,17.726a2.224,2.224,0,0,1,1.147-.368H27.7v-2.4A11.428,11.428,0,0,1,38.838,3.283,11.428,11.428,0,0,1,49.977,14.955v2.4h.78a2.225,2.225,0,0,1,1.145.367L63.326,7.371a4.595,4.595,0,1,1,2.465,2.462L52.953,21.641c0,1.827,0,4.748-.005,7.759l16.068,1a4.709,4.709,0,0,1,4.258-2.853,4.573,4.573,0,1,1,0,9.146,4.436,4.436,0,0,1-4.258-2.881l-16.07-1c-.005,5.218.037,6.6.028,6.659a6.6,6.6,0,0,0-7.211-1.07V32.8a6.516,6.516,0,0,0-6.52-6.485A6.586,6.586,0,0,0,32.716,32.8v8.559Zm4.23-26.4v2.4H46.565v-2.4a7.92,7.92,0,0,0-7.627-8.188A7.92,7.92,0,0,0,31.311,14.955Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessControl);
export default __webpack_public_path__ + "static/media/ic_access_control.fd7e029698d8791e524f6a91250fa3fd.svg";
export { ForwardRef as ReactComponent };